import { Box, HStack, Image, Text } from '@chakra-ui/react';
import {
  Button,
  ClientOnly,
  Grid,
  Marquee,
} from '@time-line/components/common';
import { ArrowRight, Soundbars } from '@time-line/components/icons';
import { clamp } from '@time-line/components/utils';
import { BLOG } from 'lib/constants/routes';
import NextLink from 'next/link';
import type { PodcastBanner as PodcastBannerProps } from 'types/cms/blocks';

export function PodcastBanner({
  episodeTitle,
  podcastTitle,
  slug,
  thumbnail,
  duration,
}: PodcastBannerProps) {
  return (
    <Box
      className="section--podcast-banner"
      my={{
        base: 'xs',
        lg: 'm',
      }}
      sx={{
        '&:first-of-type': { pt: 'lg' },
        '&:last-of-type': { pb: [0, null, null, null, '2xl'] },
      }}
    >
      <Grid overflow="hidden" gridRowGap={0}>
        <Grid.Inner
          pos="relative"
          alignItems="center"
          py="2xl"
          px={{ lg: '112px' }}
          gridColumn={{ base: 'full', lg: 'main' }}
          overflow="hidden"
          borderRadius={{ lg: 'base' }}
          bgColor="blackAlpha.100"
          position="relative"
        >
          <Box gridColumn="span 12" pos="relative" zIndex={1}>
            <Box
              gap={{ base: 'm', lg: 'lg' }}
              display={{ base: 'block', lg: 'flex' }}
              flexDir="row"
              alignItems="center"
            >
              {thumbnail && (
                <Image
                  src={thumbnail}
                  borderRadius="lg"
                  alt="podcast thumbnail"
                  boxSize={{
                    base: clamp(120, 230, 'sm', 'lg'),
                    lg: clamp(216, 230, 'lg', 'xl'),
                  }}
                  mx="auto"
                  mb={{ base: 'm', lg: 0 }}
                  flexShrink={0}
                  boxShadow="0px 2px 28px 0px rgba(0, 0, 0, 0.14)"
                />
              )}
              <Box overflow="hidden">
                <HStack
                  mb={{ base: '4xs', lg: '3xs' }}
                  justifyContent={{ base: 'center', lg: 'start' }}
                  mx={{ base: 'sm', lg: 0 }}
                >
                  <Soundbars color="blackAlpha.700" boxSize="sm" />
                  <Text as="h5" size="title2" color="blackAlpha.700">
                    Podcast · {duration} min.
                  </Text>
                </HStack>
                <ClientOnly>
                  <Marquee
                    clipGradientWidth={24}
                    speed={{
                      base: 10,
                      lg: 15,
                    }}
                  >
                    <Text
                      size={{ base: 'h3', md: 'h2' }}
                      as="h3"
                      color="gray.600"
                      noOfLines={1}
                      px="xs"
                    >
                      {episodeTitle}
                    </Text>
                    <Text
                      size={{ base: 'h3', md: 'h2' }}
                      as="h3"
                      color="gray.600"
                      noOfLines={1}
                      px="xs"
                    >
                      {episodeTitle}
                    </Text>
                  </Marquee>
                </ClientOnly>
                <Box mx={{ base: 'sm', lg: 0 }}>
                  <Text
                    textAlign={{ base: 'center', lg: 'left' }}
                    size={{ base: 'h3', md: 'h2' }}
                    as="h3"
                    color="blackAlpha.500"
                    noOfLines={1}
                    mb="m"
                  >
                    {podcastTitle}
                  </Text>
                  {slug && (
                    <Button
                      as={NextLink}
                      href={`${BLOG}/${slug}`}
                      isWide
                      width={{ base: '100%', lg: 'auto' }}
                      colorScheme="gray"
                      rightIcon={<ArrowRight />}
                    >
                      Listen now
                    </Button>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid.Inner>
      </Grid>
    </Box>
  );
}
